export default __webpack_public_path__ + "static/media/template_business-man__0016_11---ChinWeiLim.0aa05afc.png";